import { Check } from "lucide-react";

export const OptionCard = ({ selected, onClick, icon: Icon, title, hint, testId, compact }) => (
  <button type="button" onClick={onClick} data-testid={testId} aria-pressed={selected}
    className={`group relative flex w-full items-center gap-4 rounded-2xl border bg-white px-4 text-left transition-[border-color,box-shadow,transform] duration-200 active:scale-[0.98] focus-visible:outline-none ${compact ? "py-4" : "py-5"} ${
      selected ? "border-[color:var(--brand)] shadow-[0_0_0_3px_color-mix(in_srgb,var(--brand)_18%,transparent)]" : "border-slate-200 shadow-soft hover:border-slate-300"}`}>
    {Icon && (
      <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition-colors duration-200 ${selected ? "bg-[color:var(--brand)] text-white" : "brand-tint text-[color:var(--brand)]"}`}>
        <Icon className="h-5 w-5" strokeWidth={1.75} />
      </span>
    )}
    <span className="min-w-0 flex-1">
      <span className="block text-base font-semibold text-slate-900">{title}</span>
      {hint && <span className="mt-0.5 block text-sm text-slate-500">{hint}</span>}
    </span>
    <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors duration-200 ${
      selected ? "border-[color:var(--brand)] bg-[color:var(--brand)] text-white" : "border-slate-300 bg-white"}`}>
      {selected && <Check className="h-3.5 w-3.5" strokeWidth={3} />}
    </span>
  </button>
);
